
    import '/opt/buildhome/repo/packages/x/docs/x-markdown/components-infographic.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-markdown-components-infographic-demo-infographic"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/x-markdown/components-infographic.zh-CN.md?type=demo')
};